import { render } from "./side-by-side.vue?vue&type=template&id=707f8b60"
import script from "./side-by-side.vue?vue&type=script&lang=js"
export * from "./side-by-side.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__